import { defineFieldFormInterface } from "~/entities/field";
import BooleanInterface from "./boolean.vue";

export default defineFieldFormInterface({
  interface: "boolean",
  component: BooleanInterface,
});
